const columns = [
  { name: 'agent_id', title: 'Beraternummer' },
  { name: 'surname', title: 'Name' },
  { name: 'name', title: 'Vorname' },
  { name: 'email_corp', title: 'Geschäfts email' },
  { name: 'mobile', title: 'Handynummer' },
  { name: 'city', title: 'Stadt' },
  { name: 'address', title: 'Straße / Hausnummer' },
  { name: 'zip', title: 'PLZ' },
  { name: 'start_date', title: 'Leistungsbeginn' },
  { name: 'end_date', title: 'Leistungsende' },
  { name: 'customer_id', title: 'Kundennummer' },
];

export default columns;
